import { render, staticRenderFns } from "./storyList.vue?vue&type=template&id=bd41630a"
import script from "./storyList.vue?vue&type=script&lang=js"
export * from "./storyList.vue?vue&type=script&lang=js"
import style0 from "./storyList.vue?vue&type=style&index=0&id=bd41630a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports